import { ContentPage } from "@/components/organisms";

export const AboutPage = () => {
  const pageHeader = "About PharmDs in IT";

  const paragraphObject = [
    {
      header: "Introduction",
      paragraph: `Hi, I’m Khanh Theresa Mai, a clinical pharmacist turned fullstack
                    software engineer with a passion for leveraging technology to
                    improve healthcare. I like to build beautiful, clean code for me 
                    and for others, so that the processes in our lives are not just more 
                    efficient, but most efficient.`,
    },
    {
      header: "My Journey",
      paragraph: `I had been working in the hospital setting for over 7 years upon graduation. During pharmacy school, I
                    was self-teaching Python, namely because I enjoy exercising my brain
                    and I found it interesting. At the 7-year marker, I was burnt out
                    and switched to a remote informatics pharmacist role, where I
                    discovered that I really wanted to take coding more seriously. So, I
                    quit my job, attended a fullstack software engineering bootcamp, and
                    landed a job the week before bootcamp graduation. I haven't looked back since.`,
    },
    {
      header: "My Interests",
      paragraph: `Beyond my career in software
                    engineering, I also have a specific interest in pharmacogenomics,
                    space medicine, and the intersection of climate change and health.
                    I’ve been an active member of the Aerospace Medical Association
                    since 2014 and am excited to pursue further education in
                    astronautics.`,
    },
    {
      header: "My Philosophy",
      paragraph: `I believe clinicians should be a part of the process
                    of building the tools that are used in healthcare. I’m particularly
                    driven by the idea of creating solutions that help improve lives,
                    whether that’s through advancing healthcare technologies, supporting
                    clinical innovations, or contributing to the betterment of health on
                    a global scale. Since then, I have been spending time building
                    personal projects. With a healthy work/life balance, I was able to build those
                    projects on my off time, I think everyone, even clinicians, deserve that 
                    kind of time for themselves.`,
    },
    {
      header: "Link With Me",
      links: [
        "https://www.linkedin.com/in/astropharmacist/",
        "https://github.com/khanderz",
      ],
    },
  ];

  return (
    <ContentPage
      componentName="about"
      pageHeader={pageHeader}
      paragraphObject={paragraphObject}
    />
  );
};
